import MetricSeries, { MetricSeriesStrings } from 'enums/MetricSeries'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'

const metricSeriesToMeasure: Record<MetricSeriesStrings, MeasureTypeStrings> = {
  [MetricSeries.UNIQUE_AUTHORS]: MeasureType.UNIQUE_AUTHORS,
  [MetricSeries.TOTAL_BUZZ]: MeasureType.MENTIONS,
  [MetricSeries.TOTAL_BUZZ_POST]: MeasureType.POSTS,
  [MetricSeries.IMPRESSIONS]: MeasureType.IMPRESSIONS,
  [MetricSeries.NET_SENTIMENT_ON_UNIQUE_AUTHORS]: MeasureType.NET_SENTIMENT,
  [MetricSeries.PASSION_ON_UNIQUE_AUTHORS]: MeasureType.PASSION_INTENSITY,
  [MetricSeries.POSITIVE_SENTIMENT_ON_UNIQUE_AUTHORS]: MeasureType.POSITIVES,
  [MetricSeries.NEGATIVE_SENTIMENT_ON_UNIQUE_AUTHORS]: MeasureType.NEGATIVES,
  [MetricSeries.NET_SENTIMENT]: MeasureType.NET_SENTIMENT,
  [MetricSeries.PASSION]: MeasureType.PASSION_INTENSITY,
  [MetricSeries.POSITIVE_SENTIMENT]: MeasureType.POSITIVES,
  [MetricSeries.NEGATIVE_SENTIMENT]: MeasureType.NEGATIVES
}

export default metricSeriesToMeasure
